import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { getTopRatedMovies, getGenreLabel, formatDate } from "@/lib/movie";

export default function TopRatedSection() {
  const list = getTopRatedMovies(6);
  return (
    <section className="w-full max-w-[1360px] mx-auto px-4 md:px-6 py-14 md:py-16">
      <SectionHeading
        title="高分口碑榜"
        subtitle="综合评分排序，这些影片值得优先加入观影清单"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {list.map((movie, i) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group flex items-center gap-4 rounded-lg bg-background-50 border border-background-200 p-3.5 hover:border-accent-300 transition-colors cursor-pointer"
          >
            <span className="w-8 text-center font-display font-bold text-2xl text-accent-500 shrink-0">
              {i + 1}
            </span>
            <div className="w-[62px] h-[92px] rounded-md overflow-hidden bg-background-200 shrink-0">
              <img
                src={movie.poster}
                alt={`${movie.title} 电影海报`}
                title={`${movie.title} - 最新电影评分`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-semibold text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 truncate">
                {movie.genres.map((g) => getGenreLabel(g)).join(" · ")}
              </p>
              <p className="text-xs text-foreground-400 mt-1">上映 {formatDate(movie.releaseDate)}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="font-display font-bold text-xl text-secondary-600">
                {movie.rating.toFixed(1)}
              </p>
              <p className="text-[10px] text-foreground-400">综合评分</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}